import { ElementsPropertyRenderComponent } from './elementspropertyrender.component';
import { join } from 'path';
import { CustomFormUtilsService } from './../../custom-form-utils.service';
import { JsonExporterService } from './../../json-exporter.service';
import { IdPropertyComponent } from './idpropertyfield.component';
import { NbToastrService } from '@nebular/theme';
import { TYPE_FIELD_LIST, FIELD_TYPE_VALUES } from './customformsConstants';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomformsService } from '../../apiclient';
import { UserSessionService } from '../../UserSession/user-session.service';
import {Location} from '@angular/common';
import { LocalDataSource } from 'ng2-smart-table';
import { ExtraPropertyFieldEditorComponent } from './extrapropertyfield.component';
import { TypePropertyFieldComponent } from './typepropertyfield.component';
import { DependencyGroupComponent } from './dependencyGroup.component';
import { EventsComponent } from './events.component';
import { ElementsPropertyFieldComponent } from './elementspropertyfield.component';

import { CriteriosValidacionComponent } from './criteriosvalidacion.component';
import { ValorTraducidoComponent } from './valortraducido.component';
import { ValorTraducidoEventComponent } from './valortraducidoevent.component';
import { CustomCriteriaService } from './customCriteriaService';
import { Observable } from 'rxjs';


/**
 * Componente que renderiza el editor de Custom Forms
 */
@Component({
  selector: 'ngx-customform-editor',
  templateUrl: './customform-editor.component.html',
  styleUrls: ['./customform-editor.component.scss']
})
export class CustomformEditorComponent implements OnInit {

  customform: any = {};
  idcompany: string;
  idcustomform: string;
  customformOptions: any = [
    {name: 'Cuaderno de campo',
      value: 'fieldnotebook'},
      {name: 'Muestreos',
      value: 'sampling'},
      {name: 'Subformulario',
      value: 'subform'}
  ];
  dependencyGroupsSource:any;
  fieldssettings = {
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
  },

    add: {
      addButtonContent: '<i class="eva eva-plus-outline"></i>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmCreate:true,
    },
    edit: {
      editButtonContent: '<i class="eva eva-edit-outline"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmSave:true,
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline"></i>',
    },
    pager:{
      display:false,
    },

    columns: {
      id: {
        title: 'ID',
        type: 'text',
        editor: {
          type: 'custom',
          component: IdPropertyComponent,
        }

      },

      pos: {
        title: 'Posicion',
        type: 'text',
        sort:true,
        sortDirection:'asc',
        compareFunction:(direction: any, a: any, b: any) => {

          if (+a < +b) {
              return -1 * direction;
          }
          if (+a > +b) {
              return direction;
          }
          return 0;
      },
      },
      type: {
        title: 'Tipo',
        type: 'text',
        valuePrepareFunction: (value,row) => {

         if(value === 'customentity_list'){
          return this.customFormUtilsService.getEntityName(row.customEntityConfig.entity);
         }else{
          return FIELD_TYPE_VALUES[value];
         }


        },
        editor: {
          type: 'custom',
          component: TypePropertyFieldComponent,
        }
      },
      title: {
        title: 'Título',
        type: 'string',
      },
      required: {
        title: 'Obligatorio',
        type: 'text',
        editor: {
          type: 'checkbox'  ,
          config :{
            true: 'true',
            false: 'false',
          }
        }
      },
      resetResend: {
        title: 'Descartar',
        type: 'text',
        editor: {
          type: 'checkbox'  ,
          config :{
            true: 'true',
            false: 'false',
          }
        }
      },

      criteria: {
        title: 'Criterios de validación',
        type: 'custom',
        hide: true,
        editor: {
          type: 'custom',
          component: CriteriosValidacionComponent,
        },
        renderComponent: ValorTraducidoComponent
      },
      elements: {
        title: 'Elementos de lista',
        type: 'custom',
        width: '100px',
        class: 'list-elements-column',
        renderComponent:ElementsPropertyRenderComponent,
        editor: {
          type: 'custom',
          component: ElementsPropertyFieldComponent,
        }
      },
      auto: {
        title:'Auto Localización',
        type: 'text',
        editor: {
          type: 'checkbox'  ,
          config :{
            true: 'true',
            false: 'false',
          }
        }
      }
    },
  };
  dependenciessettings = {
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
  },

    add: {
      addButtonContent: '<i class="eva eva-plus-outline"></i>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmCreate:true,
    },
    edit: {
      editButtonContent: '<i class="eva eva-edit-outline"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmSave:true
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline"></i>',
    },
    pager:{
      display:false,
    },

    columns: {
      group: {
        title: 'Grupo',
        type: 'text',
        editor: {
          type: 'custom',
          component: DependencyGroupComponent,
        }

      },


    },
  };

  eventssettings = {
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
  },

    add: {
      addButtonContent: '<i class="eva eva-plus-outline"></i>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmCreate:true,
    },
    edit: {
      editButtonContent: '<i class="eva eva-edit-outline"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
      confirmSave:true,
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline"></i>',
    },
    pager:{
      display:false,
    },

    columns: {
      event: {
        title: 'Acción',
        type: 'custom',
        editor: {
          type: 'custom',
          component: EventsComponent,
        },
        renderComponent: ValorTraducidoEventComponent
      },
    },
  };
  source: LocalDataSource = new LocalDataSource();
  sourceDependencies: LocalDataSource = new LocalDataSource();
  sourceEvents: LocalDataSource = new LocalDataSource();

  loading: boolean = false;
  archivoCampos: File;
  constructor(private route: ActivatedRoute,
    private customformsService: CustomformsService,
    private userSessionService: UserSessionService,
    private customFormUtilsService: CustomFormUtilsService,
    private location: Location,
    private nbToastrService: NbToastrService,
    private jsonService: JsonExporterService) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.idcompany = params.get('companyid');
      this.customFormUtilsService.editingCompany(this.idcompany)
      this.idcustomform = params.get('idform');

      if(this.idcustomform != '0'){


      this.customformsService.getcustomform(this.idcustomform,this.userSessionService.accessToken).subscribe((data) => {
        this.customform = JSON.parse(JSON.stringify(data)) ;

        this.customform.dynamic_form.Fields.forEach(element => {
          if(element.type == 'select' && element.multiselect == true){
            element.type= 'multi_select';
          }

          if(element.type == 'picture' && element.compressImg == true){
            element.type= 'picture_compress';
          }
        });

        // Fix #276 Pos por defecto para los campos name y area
        this.source.load(this.customform.dynamic_form.Fields);

      if(this.customform.dynamic_form.dependencyGroups != undefined){

          this.sourceDependencies.load(this.customform.dynamic_form.dependencyGroups.map(g => {return {'group':g}}))
        }

        if(this.customform.events != undefined){
            //Cargo los eventos pero convirtiendelos en un array de objetos de una única propiedad event (para que coincida con el nombre del campo en eventsSettings)
          this.sourceEvents.load(this.customform.events.map(e => {
            return {"event" : e as String}
          }))
        }

      });
    }

    this.customFormUtilsService.setPropertiesDataSource(this.source)
    })
  }


  /**
   * Regresa a la página anterior
   */
  back(): void{
    this.location.back()
  }

  /**
   * Guarda el customform en edición
   */
  async guardar(): Promise<void>{
    this.loading = true;

    let valoresSource:any = {};
    let valoresDependency:any = {}
    let valoresEvents:any = {};

      await this.source.getElements().then((valores) =>{
        console.log(valores);
        try{
        valores.forEach(element => {
          if( typeof element.elements == 'string'){
            element.elements = element.elements.split(",");

          }
          if(typeof element.title == 'undefined' || element.title == null || element.title == ''){
            throw({code:'emptyTitle',message:'El título no puede estar vacio'});
          }
          if(typeof element.id == 'undefined' || element.id == null || element.id == ''){

            element.id = this.camelize(element.title);
          }

          if(typeof element.type != 'undefined' && element.type == 'multi_select'){
            element.type = 'select';
            element.multiselect = true;
          }


          if(typeof element.type != 'undefined' && element.type == 'picture_compress'){
            element.type = 'picture';
            element.compressImg = true;
          }else if(typeof element.type != 'undefined' && element.type == 'picture'){
            element.compressImg = false;
          }

          if(typeof element.type != 'undefined' && element.type == 'customentity_list' && element.customEntityConfig.multiple != undefined){
            element.multiselect = element.customEntityConfig.multiple;
            delete element.customEntityConfig.multiple

          }

          if(typeof element.type != 'undefined' && element.type == 'subform' ){
            element.subformConfig.ocurrencies = element.subformConfig.ocurrencies != '' ? element.subformConfig.ocurrencies : 0;
          }

          if(typeof element.type != 'undefined' && element.type == 'sequence' ){
            element.initValue = element.initValue != '' ? element.initValue : 1;
            element.stepValue = element.stepValue != '' ? element.stepValue : 1;
          }

          delete element.company;
        });
      }catch(error){
        this.nbToastrService.danger(error.message,"Error al guardar");
        this.loading = false;
        return;
      }
        console.log(valores);
        valoresSource = valores;
      })

      await this.sourceDependencies.getElements().then((valores)=>{
        valoresDependency = [];
        try{
          valores.forEach(element => {
            console.log(element.group)

            valoresDependency.push(element.group)
          });



        }catch(error){
          this.nbToastrService.danger(error.message,"Error al guardar");
          this.loading = false;
          return;
        }

      })

      valoresEvents = (await this.sourceEvents.getElements()).map(e => e.event);



      if(this.idcustomform == '0'){

        this.customform.dynamic_form = {Fields : valoresSource};
        this.customform.company_id = +this.idcompany;
        this.customform.dynamic_form.dependencyGroups = valoresDependency;
        this.customform.events = valoresEvents;
        this.customform.id = 0;
        this.customformsService.createcustomform(this.customform,this.userSessionService.accessToken).subscribe((data) => {
          this.loading = false;
          this.nbToastrService.success('Guardado con éxito','Guardar')
          this.customform = data;
          this.idcustomform = this.customform.id;
          this.source.load(this.customform.dynamic_form.Fields);
          console.log(data);

        })

      }else{
        this.customform.dynamic_form.Fields = valoresSource;
        this.customform.dynamic_form.dependencyGroups = valoresDependency;
        this.customform.events = valoresEvents;
        this.customformsService.updatecustomform(this.idcustomform,this.customform,this.userSessionService.accessToken).subscribe((data) => {


          this.loading = false;
          this.nbToastrService.success('Guardado con éxito','Guardar')
          console.log(data);
        })
      }
  }

   camelize(str): string  {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '').replace(/\W/g, '_');
  }

  confirmarEdFila(event) {
    if(typeof event.newData.type == 'object' && event.newData.type.fieldType == 'sequence'){
      event.newData.initValue = event.newData.type.initVal;
      event.newData.stepValue = event.newData.type.stepVal;
      event.newData.type = event.newData.type.fieldType;
    }

    event.confirm.resolve(event.newData)

  }
  /**
   * Confirma la edición de un registro (campo) del customform
   * @param event
   */
  confirmarFila(event) {

    let idcampo = this.camelize(event.newData.title)
    let idToMatch = idcampo;
    let arrdata = event.source.data
    let nMatches = -1;
    do{
      nMatches ++;

      if(nMatches > 0){
        idToMatch = idcampo+"_"+nMatches;
      }

    }while(arrdata.find(element => element.id == idToMatch))

    event.newData.id = idToMatch;
    console.log(event)


    if(typeof event.newData.type == 'object' && event.newData.type.fieldType == 'sequence'){
      event.newData.initValue = event.newData.type.initVal;
      event.newData.stepValue = event.newData.type.stepVal;
      event.newData.type = event.newData.type.fieldType;
    }

    if(event.newData.title == "" || event.newData.type == "" ){
      this.nbToastrService.danger("El tipo de campo y el título son elementos obligatorios","Error al añadir campo");
      event.confirm.reject()
    }else{
      event.confirm.resolve(event.newData)
    }



  }

  async confirmarDependencia(event){

    var entidadesRelacionadas = (await this.source.getElements()).filter(f => event.newData.group.includes(f.id)).map(f => f.customEntityConfig.entity);
    entidadesRelacionadas = [...new Set(entidadesRelacionadas)]
    if(entidadesRelacionadas.length == 1){
      event.confirm.resolve(event.newData);
      return;
    }
    var entidades = await this.customFormUtilsService.getCompanyEntities();
    for(let er of entidadesRelacionadas){
       var joins = entidades.find(e => e.id == er).joins
       var attrJoins = entidades.find(e => e.id == er).attributejoins.map(aj => (aj as any).entity);
       var relacionada = false;
       for(let j of joins){
          if(entidadesRelacionadas.includes(j)){
            relacionada = true;
          }
       }
       for(let aj of attrJoins){
        if(entidadesRelacionadas.includes(aj)){
          relacionada = true;
        }
       }

       if(relacionada == false){
        event.confirm.reject()
        this.nbToastrService.danger('Alguno de los campos incluidos en el grupo de dependencias no tiene establecida relación con el resto del grupo','Error en Grupo de dependencias');
        return;
      }

    }
    event.confirm.resolve(event.newData)
  }
  /**
   * @ignore
   * @param archivos
   */
  actualizarArchivo(archivos: FileList){

    this.archivoCampos = archivos.item(0);



  }

  /**
   * Importa los campos dedes un JSON
   */
  async importarCampos(){
    const customentities = await this.promisify(this.userSessionService.getCachedCustomEntitiesFullList(this.idcompany))
      this.jsonService.importJson(this.archivoCampos).then(fieldData => {
            fieldData = (fieldData as [any]).map(f => {
              if(f.type== 'customentity_list' && f.customEntityConfig.entityType != undefined && f.customEntityConfig.entityType != null){
                const typeEntities = (customentities as [any]).filter(e => Number(e.type) === Number(f.customEntityConfig.entityType))

                if(typeEntities.length == 1  && typeEntities[0].attributes.find(a => a.id == f.customEntityConfig.key) != undefined){
                    f.customEntityConfig.entity = typeEntities[0].id;
                    delete f.customEntityConfig.entityType;
                    return f;
                }
              }else if (f.type=='customentity_list' && (customentities as [any]).find(c => c.id == f.customEntityConfig.entity) != undefined){
                delete f.customEntityConfig.entityType;
                return f;
              }else if(f.type !='customentity_list'){
                return f;
              }

            })
            this.source.load(fieldData.filter(fd => fd!=undefined))
            this.nbToastrService.success("Los campos se han importado correctamente","Importación campos")
      }).catch(error => {
        this.nbToastrService.danger("El archivo introducido no contiene un JSON válido","Error al importar")
      })
  }

  /**
   * Exporta los campos a un JSON
   */
  exportarCampos(){
    this.source.getElements().then(campos => {
      this.jsonService.exportJson(this.customform.form_name,campos,this.idcompany)
    })

  }

        /**
   * @ignore
   * @param obser
   * @returns
   */
        async promisify(obser: Observable<any>){
          return new Promise(resolve => {
            obser.subscribe((v) => {
              resolve(v)
            })
          })
      }

  confirmarEdFilaEvents(event) {

    event.confirm.resolve(event.newData)

  }
/**
 * Confirma la edición de un evento del customform
 * @param event
 */
  confirmarFilaEvents(event) {

    let idcampo = event.newData.event
    let idToMatch = idcampo;
    let arrdata = event.source.data
    let nMatches = -1;
    do{
      nMatches ++;

      if(nMatches > 0){
        idToMatch = idcampo+"_"+nMatches;
      }

    }while(arrdata.find(element => element.id == idToMatch))

    event.newData.event = idToMatch;
    console.log(event)

    event.confirm.resolve(event.newData)
  }
}
